const aspirantPageImagePaths = {
  homePage: {
    icon1: require('/public/images/Aspirants/aspirant-home-icon.png').default,
    icon2: require('/public/images/Aspirants/aspirant-home-icon-1.png').default,
    banner: require('/public/images/Aspirants/aspirants banner.svg').default,
    rsLogo: require('/public/images/Aspirants/secondary-logo-1.svg').default,
    m: require('/public/images/Aspirants/m.svg').default,
    e: require('/public/images/Aspirants/e.svg').default,
    n: require('/public/images/Aspirants/n.svg').default,
    u: require('/public/images/Aspirants/u.svg').default,
    signUp: require('/public/images/Aspirants/sign-in-bold.svg').default,
  },
  tickerSection: {
    arrow: require('/public/images/Aspirants/Arrow.svg').default,
  },
  dropDownSection: {
    mainImage1: require('/public/images/Aspirants/college-students.png')
      .default,
    mainImage2:
      require('/public/images/Aspirants/experienced-professionals.png').default,
    trophy: require('/public/images/Aspirants/aspirants-vector.svg').default,
    spring: require('/public/images/Aspirants/arrow-1.svg').default,
    forStudents: {
      icon1: require('/public/images/Aspirants/college-to-career-roadmap.svg')
        .default,
      icon2: require('/public/images/Aspirants/gain-insights.svg').default,
      icon3: require('/public/images/Aspirants/stay-ahead.svg').default,
      icon4: require('/public/images/Aspirants/attract-best-salaries.svg')
        .default,
    },
    forProfessonal: {
      icon1: require('/public/images/Aspirants/enrich-your-profile.svg')
        .default,
      icon2: require('/public/images/Aspirants/bridge-skill-gap.svg').default,
      icon3: require('/public/images/Aspirants/be-a-specialist.svg').default,
      icon4: require('/public/images/Aspirants/get-verified.svg').default,
    },
  },
  fastrackSection: {
    runnerImage: require('/public/images/Aspirants/runner.svg').default,
  },
  getStartedSection: {
    questionTag: require('/public/images/Aspirants/question-vector.svg')
      .default,
    qrCode: require('/public/images/Aspirants/QR Code for RS Whatsapp.jpg')
      .default,
  },
  styickScrollSection: {
    image1: require('/public/images/Aspirants/scan-and-sign-in.svg').default,
    image2: require('/public/images/Aspirants/get-verified-get-hired.svg')
      .default,
    image3: require('/public/images/Aspirants/specialise-with-pathways.svg')
      .default,
    image4: require('/public/images/Aspirants/career-management.svg').default,
  },

  footerSectonSocialIcons: {
    linkedIn: require('/public/images/Aspirants/linkedin-logo.svg').default,
    facebook: require('/public/images/Aspirants/facebook-logo.svg').default,
    twitter: require('/public/images/Aspirants/x-logo.svg').default,
    instagram: require('/public/images/Aspirants/insta-logo.svg').default,
  },
  coursesImages: {
    bannerImage: require('/public/images/Aspirants/hero-image-courses.png')
      .default,
    google: require('/public/images/Aspirants/google.png').default,
    qrImage: require('/public/images/Aspirants/courses-qr-code.jpg').default,
    image1: require('/public/images/Aspirants/Asset-36.svg').default,
  },
};
export default aspirantPageImagePaths;
